import React from 'react';
import { Navigate } from 'react-router-dom';

// Le composant reçoit le statut d'authentification et la composante cible
const ProtectedRoute = ({ authUser, children }) => {
  return authUser ? children : <Navigate to="/" />;
};

export default ProtectedRoute;